import React from "react";
import PropTypes from "prop-types";
import { KNOWLEDGE_SOURCE_STATUS } from "../utils/constants";
import "./StatusBadge.css";

const StatusBadge = ({ status }) => {
  const config = KNOWLEDGE_SOURCE_STATUS[status] || {
    label: status,
    className: "",
  };

  return (
    <span className={`badge-base status-badge ${config.className}`}>{config.label}</span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.oneOf(["processing", "completed", "failed"]).isRequired,
};

export default StatusBadge;
